<template>
  <van-swipe-cell :disabled="disableSwipe">
    <div class="item-main"
      @click="showDetail(data.id)">
      <div class="item-img">
        <van-image :src="data.originalLogo" />
      </div>
      <div class="item-info">
        <div class="item-head">
          <div class="head-name"
            v-text="data.name"></div>

          <van-tag plain
            type="primary"
            class="my-tag">
            {{ data.industryField }}
          </van-tag>
        </div>
        <div class="item-prefer">
          <label>{{ data.brief }}</label>
        </div>
        <div class="item-down">
          <span>最近获投：</span><span>{{ data.latestInvestmentDesc }}</span>
        </div>

        <div class="div-chk"
          v-show="showChk">
          <van-checkbox v-model="data.checked"
            checked-color="#c52a1a"></van-checkbox>
        </div>
      </div>
    </div>
    <template #right>
      <div class="cell-right"
        @click="cancelMark(data.id)">
        &nbsp;&nbsp; 取消收藏&nbsp;&nbsp;
      </div>
    </template>
  </van-swipe-cell>
</template>

<script>
import { Dialog } from "vant";
export default {
  data () {
    return {};
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
    showChk: {
      type: Boolean,
      required: false,
    },
    disableSwipe: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  components: {},

  computed: {},

  mounted () { },

  methods: {
    cancelMark (id) {
      Dialog.confirm({
        title: "提示",
        message: "确认取消收藏该被投公司",
      })
        .then(() => {
          //request

          this.$emit("cancel", id);
        })
        .catch(() => {
          // on cancel
        });
    },
    showDetail (id) {
      // this.$router.push({ path: "/investedDetail/" + id });
      if (!this.showChk) {
        this.$router.push({
          path: "/investedDetail/" + Math.random() * 1000000,
          query: {
            id: id,
          },
        });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.item-main {
  display: flex;
  padding: 0.375rem;

  border-bottom: 1px solid #f2f2f2;

  .item-img {
    width: 4rem;
    height: 4rem;
    min-width: 4rem;
    min-height: 4rem;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0.25rem;
  }

  .item-info {
    padding: 0.25rem;
    flex: 1;
    position: relative;
    width: 100%;
    .item-head {
      display: flex;
      .head-name {
        color: #2d2d2d;
        font-size: 14px;
        font-weight: bolder;
      }

      .my-tag {
        background-color: #f7f7f7;
        font-size: 0.75rem;
        color: rgb(131, 131, 131);
        padding: 4px;
        margin-right: 10px;
      }
      .my-tag::before {
        border: none;
      }
    }
    .item-prefer {
      padding: 0.5rem 0;
      font-size: 0.75rem;
      color: #7d7d7d;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 75%;
    }

    .item-down {
      color: #2d2d2d;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 95%;
      font-size: 0.75rem;
    }

    .div-chk {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.cell-right {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  // background-color: #7d7d7d;
  color: #c52a1a;
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/InvestedItem.vue